import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    inputPlaceholder: string;
    noResultsHeader: string;
    noResults: (query: string) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Placeholder text for search input field */
            inputPlaceholder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberSearch.inputPlaceholder?c=1bsuy2ze3vlpn", defaultMessage: "Search for user name or email" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Header shown above no results message */
            noResultsHeader: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberSearch.noResultsHeader?c=aq9w62hyjrax", defaultMessage: "Search result" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message displaying search query with no results */
            noResults: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (query: string) => __intl__.intl().formatMessage({ id: "MemberSearch.noResults?c=2q40upxzt6ngz", defaultMessage: "No result found for \"{query}\"" }, { query: query }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
